import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip } from '@/components/TableCell';
import { regFenToYuan, } from '@/util/money';

class TableContent extends React.Component {

    _columns = () => [
        {
            title: '模版名称',
            dataIndex: 'templateName',
            key: 'templateName',
            width: '25%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '基础运费',
            dataIndex: 'baseFee',
            key: 'baseFee',
            width: '25%',
            align: 'center',
            onCell: tooltipStyle,
            render: (fee) => (
                <div>
                    {fee.map(v => <p>{`${v.leftCloseInterval / 1000}~${v.rightOpenInterval / 1000}公里（${regFenToYuan(v.cost)}元，${parseInt(v.time) / 60}分钟）`.replace(/NaN/g, '-')}</p>)}
                </div>
            )
        },
        {
            title: '重量附加费',
            dataIndex: 'weightFee',
            key: 'weightFee',
            width: '25%',
            align: 'center',
            onCell: tooltipStyle,
            render: (fee) => (
                <div>
                    {fee.map(v => <p>{`${parseFloat(v.leftCloseInterval) / 1000}~${parseFloat(v.rightOpenInterval) / 1000}公斤（${regFenToYuan(v.cost)}元）`.replace(/NaN/g, '-')}</p>)}
                </div>
            )
        },
        {
            title: '时段附加费',
            dataIndex: 'periodFee',
            key: 'periodFee',
            width: '25%',
            align: 'center',
            onCell: tooltipStyle,
            render: (fee) => (
                <div>
                    {fee.map(v => <p>{`${v.leftCloseInterval}~${v.rightOpenInterval}（${regFenToYuan(v.cost)}元，${parseInt(v.time) / 60}分钟）`.replace(/NaN/g, '-')}</p>)}
                </div>
            )
        },
    ];

    _takeDataSource = (data) => {
        if (Array.isArray(data)) {
            return data;
        } else {
            return [];
        }
    }

    _TableAction = (record) => {
        const { tableAction } = this.props;
        const disable = record.status == 'DISABLE' || record.status == 'BLACK' ? true : false;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', record)}>查看详情</div>
                <div className={styles.item} onClick={() => tableAction('available', record)}>{disable ? '启用' : '禁用'}</div>
            </div>
        );
    };

    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    columns={this._columns()}
                    rowKey={(r) => r.templateId}
                    rowSelection={rowSelection}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};
export default TableContent;

